import { messages } from '../../common/data';
import { apiListTypes } from './actionTypes';

const INIT_STATE = {
  listData: [],
  apiAdd: {},
  deleteId: undefined,
  updateApi: {},
  error: '',
  success: '',
  testApi: '',
  locations: [],
  message: '',
  isLoading: false,
};

const ApiList = (state = INIT_STATE, action: any) => {
  switch (action.type) {
    // GET API LIST
    case apiListTypes.GET_API_LIST:
      return {
        ...state,
        isLoading: true,
      };
    case apiListTypes.GET_API_LIST_SUCCESS:
      return {
        ...state,
        listData: action.payload,
        apiAdd: {},
        isLoading: false,
      };
    case apiListTypes.GET_API_LIST_FAIL:
      return {
        ...state,
        error: action.payload,
        listData: [],
        apiAdd: {},
        isLoading: false,
      };

    // ADD API LIST
    case apiListTypes.ADD_API_LIST:
      return {
        ...state,
        isLoading: true,
      };
    case apiListTypes.ADD_API_LIST_SUCCESS:
      return {
        ...state,
        apiAdd: action.payload,
      };
    case apiListTypes.ADD_API_LIST_FAIL:
      return {
        ...state,
        error: action.payload,
        isLoading: false,
      };

    // DELETE API LIST
    case apiListTypes.DELETE_API_LIST:
      return {
        ...state,
        isLoading: true,
      };
    case apiListTypes.DELETE_API_LIST_SUCCESS:
      return {
        ...state,
        deleteId: action.payload,
      };
    case apiListTypes.DELETE_API_LIST_FAIL:
      return {
        ...state,
        error: action.payload,
        isLoading: false,
      };

    // UPDATE API LIST
    case apiListTypes.UPDATE_API_LIST:
      return {
        ...state,
        isLoading: true,
      };
    case apiListTypes.UPDATE_API_LIST_SUCCESS:
      return {
        ...state,
        updateApi: action.payload,
      };
    case apiListTypes.UPDATE_API_LIST_FAIL:
      return {
        ...state,
        error: action.payload,
        isLoading: false,
      };

    case apiListTypes.TEST_API_LIST:
      return {
        ...state,
        isLoading: true,
      };

    case apiListTypes.TEST_API_LIST_SUCCESS:
      return {
        ...state,
        testApi: 'Success',
        isLoading: false,
      };
    case apiListTypes.TEST_API_LIST_FAIL:
      return {
        ...state,
        testApi: 'Fail',
        isLoading: false,
        error: action.payload,
      };

    case apiListTypes.TEST_API_LIST_RESET:
      return {
        ...state,
        testApi: '',
      };


    case apiListTypes.GET_LOCATION_SHOPIFY:
      return {
        ...state,
        isLoading: true,
      };

    case apiListTypes.GET_LOCATION_SHOPIFY_SUCCESS:
      return {
        ...state,
        locations: action.payload.Data,
        message: action.payload.Message,
        isLoading: false,
      };
    case apiListTypes.GET_LOCATION_SHOPIFY_FAIL:
      return {
        ...state,
        locations: action.payload.Data,
        message: action.payload.Message,
        isLoading: false,
      };
    default:
      break;
  }
  return state;
};

export default ApiList;
